

import EagleWorksIntel from './EagleWorksIntel';
function App() { return <EagleWorksIntel />; }
export default App;